/* eslint-disable
max-len,
no-mixed-spaces-and-tabs,
react/jsx-indent,
react/jsx-first-prop-new-line,
*/

import React, { PureComponent, PropTypes } from 'react';
import styles from './styles.scss';

export class Checkout extends PureComponent {
  render() {
    return (
      <div className={this.props.className}>
        <svg version="1.1"
          id="BG_Details"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 598 457.5"
          xmlSpace="preserve"
          preserveAspectRatio="xMaxYMax slice"
          className={styles.st1}
        >
        <g>
          <path className={styles.st0}
            d="M46,405.6l0.8,0.2v40.7c0,0.1,0,0.1,0,0.2h373c0-0.1,0-0.1,0-0.2V308.9h9.2c1.1,0,2-0.9,2-2V275
            c0-1.1-0.9-2-2-2h-89.5l7.3-27.2h1.5c0.9,0,1.5-0.7,1.5-1.5v-10.9c0-0.9-0.7-1.5-1.5-1.5H340l-0.1-0.9c-1-15.4-12.9-24.2-32.7-24.2
            s-31.7,8.8-32.7,24.2l-0.1,0.9h-8.3c-0.9,0-1.5,0.7-1.5,1.5v10.9c0,0.9,0.7,1.5,1.5,1.5h1.5l7.3,27.2h-65.4v-21.3
            c0-5-4.1-9.2-9.2-9.2h-47.1V234h47.4c4.8,0,8.7-3.9,8.7-8.7v-76c0-4.8-3.9-8.7-8.7-8.7h-84.4v-10.8h25.2c0.9,0,1.5-0.7,1.5-1.5
            v-20.5c0-0.9-0.7-1.5-1.5-1.5H77.6c-0.8,0-1.5,0.7-1.5,1.5v20.5c0,0.9,0.7,1.5,1.5,1.5h22.2v10.8H82.1c-4.8,0-8.7,3.9-8.7,8.7v76
            c0,4.8,3.9,8.7,8.7,8.7h47.4v8.5H82.5c-5,0-9.2,4.1-9.2,9.2V273h-3.1v0.1H37c-0.8,0.3-1.4,1-1.4,1.9v31.8c0,1.1,0.9,2,2.1,2h9.2
            v21.2l-0.8,0.1c-18,3.5-31.1,19.3-31.1,37.7C14.9,386.3,28,402.1,46,405.6z M89.6,444.5H50.9v-38.2l1,0c0.4,0,0.9,0,1.3,0h36.3
            V444.5z M89.6,393H53.3c-0.5,0-0.9,0-1.4,0l0-1l-0.1,1l-0.9-0.1v-50l0.9-0.1c0.5,0,1,0,1.4,0h36.3V393z M102,444.5h-8.4V329h8.4
            V444.5z M309.8,444.5H106.1v-37.7h203.6V444.5z M309.8,402.7H106.1v-6.6h203.6V402.7z M309.8,393H106.1v-50.2h203.6V393z
             M309.8,339.7H106.1v-7.1h203.6V339.7z M322.2,444.5h-9.4v-37.7h0.5v-4.1h-0.5l0-70.6h9.3V444.5z M415.7,444.5h-90.4v-38.2h35
            c21.2,0,38.4-17.2,38.4-38.4c0-21.2-17.2-38.4-38.4-38.4h-35V327c0-0.9-0.7-1.5-1.5-1.5h-12.5c-0.8,0-1.5,0.7-1.5,1.5v2.5H106.1
            V327c0-1.1-0.9-2-2-2H91.6c-1.1,0-2,0.9-2,2v2.6H53.3c-0.4,0-0.9,0-1.3,0l-1,0v-20.7h364.8V444.5z M360.3,396.1
            c15.5,0,28.2-12.7,28.2-28.2c0-15.6-12.7-28.2-28.2-28.2h-35v-7.1h35c19.5,0,35.3,15.8,35.3,35.3c0,19.5-15.8,35.3-35.3,35.3h-35
            v-7.1H360.3z M325.3,393v-50.2h35c13.9,0,25.1,11.3,25.1,25.1c0,13.8-11.3,25.1-25.1,25.1H325.3z M339.1,262.9h-11.6l1.6-7.3h12
            L339.1,262.9z M308.7,262.9v-7.3h17.1l-1.6,7.3H308.7z M323.6,266l-1.4,6.7h-13.4V266H323.6z M308.7,252.5v-6.8H328l-1.5,6.8H308.7
            z M326.8,266h11.5l-1.8,6.7h-11.2L326.8,266z M341.9,252.5h-12.2l1.5-6.8h12.5L341.9,252.5z M277.6,230.7
            c1.5-18.9,21.2-20.9,29.6-20.9s28.1,2,29.6,20.9l0.1,1.1h-59.4L277.6,230.7z M267.6,234.9h79.2v7.5h-79.2V234.9z M290.1,262.9
            l-1.6-7.3h17.1v7.3H290.1z M305.6,266v6.7h-13.4l-1.5-6.7H305.6z M289.1,272.7h-11.2l-1.8-6.7h11.5L289.1,272.7z M287.9,252.5
            l-1.5-6.8h19.2v6.8H287.9z M270.7,245.8h12.5l1.5,6.8h-12.2L270.7,245.8z M273.4,255.6h12l1.6,7.3h-11.7L273.4,255.6z M79.2,126.8
            v-17.4h60.6v17.4H79.2z M113.1,130.1v10.1h-10.1v-10.1H113.1z M82.1,230.9c-3.1,0-5.6-2.5-5.6-5.6v-76c0-3.1,2.5-5.6,5.6-5.6h118.4
            c3.1,0,5.6,2.5,5.6,5.6v76c0,3.1-2.5,5.6-5.6,5.6h-47.4v-18.2c0-0.9-0.7-1.5-1.5-1.5h-20.5c-0.9,0-1.5,0.7-1.5,1.5v18.2H82.1z
             M150.1,214.3v28.2h-17.4v-28.2H150.1z M77.4,251.6c0-2.8,2.3-5,5.1-5h117.8c2.8,0,5.1,2.3,5.1,5v20.5H77.4V251.6z M39.2,305.3
            v-28.7h388.3v28.7H39.2z M45.6,333.5l0.6-0.2c1.5-0.3,3.2-0.5,5.1-0.6l0.7,0c0.4,0,0.8,0,1.2,0h36.3v7.1H53.3c-0.4,0-0.8,0-1.3,0
            l-0.5,0c-1.5,0.1-3.1,0.3-5.1,0.8l-0.7,0.1c-12.2,3.4-20.6,14.5-20.6,27.2c0,12.8,8.6,24,21,27.3l0.8,0.2v0.5
            c1.3,0.3,2.7,0.5,4.1,0.6V396l1.1,0.1c0.4,0,0.9,0,1.3,0h36.3v7.1H53.3c-0.4,0-0.9,0-1.4,0l-1,0v-0.5c-1.4-0.1-2.8-0.3-4.1-0.5v0.5
            l-1.2-0.3c-16-3.6-27.6-18-27.6-34.4C18,351.5,29.6,337,45.6,333.5z M46.8,343.6v48.6l-1.3-0.4c-10.4-3.4-17.4-13-17.4-23.9
            c0-10.9,7-20.5,17.4-23.9L46.8,343.6z"
          />
          <path className={styles.st0}
            d="M597.3,447.2H0.7c-0.4,0.4-0.7,0.9-0.7,1.5c0,1.1,0.9,2,2,2h594c1.1,0,2-0.9,2-2
            C598,448.1,597.7,447.5,597.3,447.2z"
          />
        </g>
        <path className={styles.st0}
          d="M433.8,273v0.1h-33.2c0.2-0.1,0.4-0.1,0.7-0.1h17.2V0.6c0-0.1,0.6-0.6,1.6-0.6c1,0,1.5,0.4,1.6,0.6l0,272.3
          H433.8z"
        />
        </svg>
      </div>
    );
  }
}

Checkout.propTypes = {
  className: PropTypes.string,
};

export default Checkout;



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_carousel/shared/checkout/index.jsx